import styled from "styled-components";
import { COLORS } from "../../../../../../../../styles/constants.style";

export const ProformaPdfTemplateWrapper = styled.div`
  width: 100%;
  padding: 50px 100px 32px 100px;
  font-family: Arial;
  .bold-label {
    font-weight: bold;
    min-width: 110px;
  }
  .table-title {
    text-align: center;
    margin: 32px 0;
  }
  .email-to-section {
    display: flex;
    margin-top: 64px;
  }
  .date-section {
    display: flex;
    margin-top: 20px;
  }
  .header-section {
    display: flex;
    flex-direction: column;
    width: 100%;
    white-space: pre-line;
  }
  .right-header .MuiTypography-root {
    text-align: justify;
    text-align-last: right;
  }
  .program-details-section {
    display: flex;
    margin-bottom: 16px;
  }
  .payment-notice-section {
    border-top: 1px solid ${COLORS.cirrus_black};
    border-bottom: 1px solid ${COLORS.cirrus_black};
    text-align: center;
    padding: 12px 0;
    margin-top: 40px;
    text-transform: uppercase;
  }
  .footer-section {
    white-space: pre-line;
    margin-top: 40px;
    .MuiTypography-root {
      font-size: 12px;
      line-height: 1.5;
    }
    .footer-link {
      color: ${COLORS.primary_light_blue};
      text-decoration: none;
    }
    .office-address {
      font-size: 8px;
    }
  }
  .sub-title {
    margin-bottom: 16px;
    font-style: italic;
  }
  .MuiTable-root {
    .MuiTableRow-root {
      vertical-align: top;
      .vertical-align-bottom {
        vertical-align: bottom;
        .MuiTypography-root:not(:last-child) {
          margin-bottom: 4px;
        }
      }
      .MuiTableCell-root {
        &:first-child {
          padding-left: 0px;
        }
        &:last-child {
          padding-right: 0px;
        }
        border-bottom: 1px solid ${COLORS.cirrus_black3};
      }
    }
  }
  .MuiTypography-root {
    font-family: Arial, sans-serif;
  }
  .MuiTableBody-root,
  .MuiTableHead-root {
    .MuiTableRow-root:last-child {
      .MuiTableCell-root {
        border-bottom: none;
      }
    }
  }
  .right-management-logo {
    width: 250px;
  }
`;
